import { render, staticRenderFns } from "./vendors-settings-page.vue?vue&type=template&id=32662173&scoped=true&"
import script from "./vendors-settings-page.vue?vue&type=script&lang=js&"
export * from "./vendors-settings-page.vue?vue&type=script&lang=js&"
import style0 from "./vendors-settings-page.vue?vue&type=style&index=0&id=32662173&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32662173",
  null
  
)

export default component.exports